<div class="logo-upload">
	<dz-toggle-switch
		[toggleOn]="includeLogo"
		[toggleLabel]="'Include Logo' | dcr: 'PDF_GENERATE_LOGO_HEADER'"
		[dcrKeys]="['PDF_GENERATE_LOGO_HEADER']"
		(click)="toggleLogo()"
		custom-tracking
		[track-event]="'pdf-logo-upload:include-logo-toggle:' + (!includeLogo ? 'on' : 'off')">
	</dz-toggle-switch>

	<section *ngIf="includeLogo" class="row dz-row padding-bottom-50">
		<section class="col-14 dz-col-14 logo-text">
			<p class="margin-bottom-20" dcrHTMLKey="PDF_GENERATE_LOGO_INTRO">Customize your report by including your firm's logo.</p>
			<section class="text-14" dcrHTMLKey="PDF_GENERATE_LOGO_ACCEPTED_FORMATS">
				<p>Accepted Formats: JPG, PNG</p>
				<p>Max file size: 2MB</p>
				<p>For best resolution, upload using Chrome</p>
			</section>
			<p dcrHTMLKey="BROWSE_UPLOAD_LOGO" class="margin-top-40 margin-bottom-30">Browse to upload your logo file or drag-and-drop onto the preview on the right.</p>
			<button dz-button color="secondary" [dropzone]="config" (error)="onError($event)" dcrHTMLKey="PDF_GENERATE_CHOOSE_FILE">Choose file for upload</button>
			<section *ngIf="logoName" class="padding-top-10">
				<span class="padding-right-5">
					<span dcrHTMLKey="PDF_GENERATE_CURRENT_LOGO">Current logo file:</span>
					<strong>{{ logoName }}</strong>
				</span>
				<button class="text-align-right logo-toggle logo-delete" (click)="toggleConfirmModal(true)">
					<icon type="trash" class="delete-icon padding-left-5"></icon>
					<span class="logo-button-text text-16-bold" dcrHTMLKey="PDF_GENERATE_DELETE_FILE">Delete File</span>
				</button>
			</section>

			<bfa-modal width="600px" [enableBackdrop]="true" [enableClose]="false" [isVisible]="showConfirmModal" (isVisibleChange)="toggleConfirmModal(false)">
				<span><img ada-decorative class="icon-warning" [remote-src]="'Alert_warning.svg'" /></span>
				<h1 class="margin-top-20 margin-bottom-20 text-20-bold text-align-center" dcrHTMLKey="LOGO_DELETE_TITLE">Logo will be deleted.</h1>
				<p class="text-14 text-align-center padding-bottom-10" dcrHTMLKey="LOGO_DELETE_TEXT">This action will permanently delete the logo file from BlackRock's system.</p>
				<section class="cropper-buttons text-align-right">
					<button dz-button color="secondary" (click)="toggleConfirmModal(false)" dcrHTMLKey="PDF_GENERATE_DELETE_CANCEL">Cancel</button>
					<button dz-button (click)="onFileDelete()" dcrHTMLKey="PDF_GENERATE_DELETE_CONFIRM">Confirm</button>
				</section>
			</bfa-modal>

			<section *ngIf="errorMessage" class="warning margin-top-30">
				<section class="warning-head">
					<icon class="warning-message-icon" type="exclamation-circle"></icon>
				</section>
				<span class="warning-message text-14" [innerHTML]="errorMessage"></span>
			</section>

			<section *ngIf="showLogoError" class="warning margin-top-30">
				<section class="warning-head">
					<icon class="warning-message-icon" type="exclamation-circle"></icon>
				</section>
				<span class="warning-message text-14" dcrHTMLKey="PDF_GENERATE_LOGO_REQUIRED">Please upload logo before proceeding.</span>
			</section>
		</section>
		<section class="col-10 logo-container">
			<div *ngIf="!reportCover || !logoBase64" class="dropzone logo-dropzone" [dropzone]="config" (error)="onError($event)">
				<div class="dz-message dropzone-content">
					<dz-icon type="arrow-down"></dz-icon>
					<p class="text-20-bold upload-text" dcrHTMLKey="PDF_GENERATE_DROP_LOGO_FILE">Drop logo file here to upload</p>
				</div>
			</div>
			<ng-container *ngIf="reportCover && logoBase64" class="report-cover">
				<div
					class="dropzone"
					[ngClass]="{
						landscape: isLandscape,
						portrait: !isLandscape
					}"
					#cover
					[dropzone]="config"
					(error)="onError($event)"
					[acSafeSvgContent]="reportCover"></div>
			</ng-container>
		</section>

		<bfa-modal *ngIf="showCropperModal" width="800px" [enableBackdrop]="true" [enableClose]="false" [isVisible]="showCropperModal" (isVisibleChange)="onCancel()">
			<h1 class="cropper-title text-20-bold" dcrHTMLKey="PDF_GENERATE_CROP_LOGO_TITLE">Adjust Size and Placement of Your Logo</h1>
			<div class="cropper">
				<ac-cropper #cropper [cropperOptions]="cropperConfig" [imageUrl]="domSanitizer.bypassSecurityTrustUrl(logoBase64Raw)"></ac-cropper>
			</div>
			<div class="row dz-row">
				<section class="dz-col-12 col-12 zoom-buttons">
					<button dz-button color="secondary" class="zoom-in" (click)="onZoomIn()">+</button>
					<button dz-button color="secondary" class="zoom-out" (click)="onZoomOut()">-</button>
				</section>
				<section class="dz-col-12 col-12 cropper-buttons text-align-right">
					<button dz-button color="secondary" (click)="onCancel()" dcrHTMLKey="PDF_GENERATE_CROP_CANCEL">Cancel</button>
					<button dz-button (click)="onImageCrop()" dcrHTMLKey="PDF_GENERATE_CROP_CONFIRM">Apply</button>
				</section>
			</div>
		</bfa-modal>
	</section>
</div>
